var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 31 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linkedin_svg__a)",
    d: "M28.508 0H2.492A2.492 2.492 0 0 0 0 2.492v26.016A2.492 2.492 0 0 0 2.492 31h26.016A2.492 2.492 0 0 0 31 28.508V2.492A2.492 2.492 0 0 0 28.508 0Zm0 28.52c-17.352-.004-26.028-.008-26.028-.012.004-17.352.008-26.028.012-26.028 17.352.004 26.028.008 26.028.012-.004 17.352-.008 26.028-.012 26.028ZM4.596 11.621h4.6v14.795h-4.6V11.62Zm2.301-2.023a2.668 2.668 0 0 0 1.886-4.55 2.666 2.666 0 0 0-4.551 1.884 2.66 2.66 0 0 0 2.665 2.666Zm9.777 9.498c0-1.93.368-3.797 2.76-3.797 2.355 0 2.39 2.204 2.39 3.921v7.196h4.596v-8.114c0-3.984-.86-7.049-5.514-7.049-2.236 0-3.736 1.228-4.352 2.39h-.062v-2.022h-4.414v14.795h4.596v-7.32Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkedin_svg__a",
    x1: 5.415,
    x2: 24.122,
    y1: 2.528,
    y2: 2.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#F0CAB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC836D"
  })))));
};
export default SvgLinkedin;